module.exports = __webpack_public_path__ + "media/applicants/device_signup_4-aac2d49f.webp";